import { graphql } from "react-relay";

export const COMMIT_LINEUP_LOCKS = graphql`
  mutation CommitLineupLockChangesMutation(
    $input: CommitLineupLockChangesInput!
  ) {
    commitLineupLockChanges(input: $input) {
      success
    }
  }
`;
